import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import { RendererProps } from "../BaseRenderer";
import { ChoiceModel } from "../../../models/ChoiceModel";
import useStyle from "./NetPromoterItemRenderer.styles";
import useTranslatable from "../../../hooks/useTranslatable";
import useDimensionContext from "../../../hooks/useDimensionContext";
import { useKeyboardNavigation } from "../../../hooks/useKeyboardNavigation";
import useQuestion from "../../../hooks/useQuestion";
import { NetPromoterNavigation } from "../../controls/KeyboardNavigation/NetPromoterNavigation";

interface Props extends RendererProps {
    choice?: ChoiceModel;
    selected?: boolean;
    onSelect?(choice: ChoiceModel): void;
}

export default function NetPromoterItemRenderer(props: Props) {
    const { choice, selected, onSelect, variable } = props;
    const theme = useTheme();
    const dimension = useDimensionContext();
    const classes = useStyle({ theme, selected, dimension });
    const label = useTranslatable(choice, "Text");
    const [active, setActive] = React.useState(false);

    const { elementReference, onKeyDown } = useKeyboardNavigation(
        choice.elementId,
        variable,
        useQuestion(),
        NetPromoterNavigation,
        () => {
            onSelect(choice);
        },
    );

    return (
        <div
            role="radio"
            ref={elementReference}
            aria-checked={selected}
            tabIndex={0}
            className={classnames(
                classes.choice,
                dimension && dimension.maxWidth(480) && classes.dynamicChoice,
                selected && classes.choiceSelected,
                active && classes.choiceActive,
            )}
            style={{}}
            onFocus={() => setActive(true)}
            onBlur={() => setActive(false)}
            onMouseOver={() => setActive(true)}
            onMouseOut={() => setActive(false)}
            onClick={() => onSelect(choice)}
            onKeyDown={onKeyDown}
        >
            <div className={classnames(classes.content, active && classes.choiceActive)}>
                <span>{label}</span>
            </div>
        </div>
    );
}
